/* eslint-disable import/no-anonymous-default-export */
export default {
    unsubscribeLanding: '/unsubscribe/landing',
  
    
    userLogin: 'POST /user/login',
    userLogout: '/user/logout',
    userLogoutAll: '/user/logout/all',
    userDelete: '/user/delete',

    userByToken: '/user',
    userPreferences: '/user/preferences',
    userLocation: 'POST /user/preferences/location',
    userPreferencesSave: 'PUT /user/preferences',
    accountProtection: '/account/protection',
    accountProtectionAppeal: 'POST /account/protection/appeal',
    userById: '/user/id/:id',
    userByUsername: '/user/username/:username',
    userUpdateFields: 'PUT /user/:id',
    userFollowsAdd: 'POST /user/follows',
    userFollowsDelete: 'DELETE /user/follows',
    userFollowers: 'POST /user/followers',

    queryPost: '/post/:id',
    queryPostList: '/posts',
    storyList: 'POST /storys',
    storyStatistic: '/storys/statistic/:id',
    storyUsers: 'POST /storys/users',
    storyComment: '/story/:id/comment',
    storyLoad: '/storys/:id',
    storyLatestOpinion: '/storys/:id/latest-opinion',
    storyAdd: 'POST /storys/add',
    postLoad: 'POST /post/load',

    reactionLoad: '/reaction/:id',
    reactionQuotes: '/reaction/:id/quotes',
    linkPreview: 'POST /links/preview',
    reactionsLoad: 'POST /reactions',
    reactionsLoadRefresh: 'POST /reactions/refresh',
    reactionLike: 'PUT /reaction/:id/like',
    reactionView: '/reaction/view/:id',
    reactionSaveVoting: 'POST /reaction/save',
    reactionPrivacy: 'PUT /reaction/:id/privacy',
    reactionDeleteById: 'DELETE /reaction/:id',
    reactionHide: '/reaction/user/hide',
    reactionClear: '/reaction/user/clear',

    getLng: '/dict/language',
    getCountry: '/dict/country',
    
    getPage: '/pages/:url'

}
